// extracted by mini-css-extract-plugin
export default {"errorMessage":"marketing_errorMessage__jEcAZ"};